import React from 'react';
import styled from 'styled-components';
import { Logo, Link } from '@components';
import { breakpoints, links } from '@config';

const Wrapper = styled.footer`
  border-top: 1px solid rgba(106, 110, 117, 0.5);
  box-sizing: border-box;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-left: 24px;
  margin-right: 24px;

  @media (min-width: ${breakpoints.pc}) {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 61px;
    display: flex;
    align-items: center;
    column-gap: 32px;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(12px);
    padding: 20px 1rem;
    margin-left: 0;
    margin-right: 0;
  }
`;

const Links = styled.div`
  display: flex;
  column-gap: 32px;
  margin-left: auto;
  margin-top: 24px;

  @media (min-width: ${breakpoints.pc}) {
    margin-top: 0;
  }
`;

const Footer: React.FC = () => {
  return (
    <Wrapper>
      <Logo />
      <Links>
        {
          links.help.href
          && <Link href={links.help.href}
                target={links.gamelab.target}
                icon={'help'}
          >
            Помощь
          </Link>
        }
        {
          links.gamelab.href
          && <Link href={links.gamelab.href}
                target={links.gamelab.target}
                icon={'hearts'}
          >
            Сделано в GL Сбера
          </Link>
        }
      </Links>
    </Wrapper>
  )
}

export { Footer };
